import { post } from "../utils/backend";
import { EnterpriseVerifyApply, EnterpriseAuditRequest } from "../models/EnterpriseAudit";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/EnterpriseAuditMock";

const getAllCandidates = async (): Promise<EnterpriseVerifyApply[]> => {
    if (mock&&false) {
        return getMockData("enterprise_candidates");
    }
    const resultOrErrorCode = await post<null, EnterpriseVerifyApply[]>("/audit/enterprise/getAllCandidates", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getAllProcessed = async (): Promise<EnterpriseVerifyApply[]> => {
    if (mock) {
        return getMockData("enterprise_processed");
    }
    const resultOrErrorCode = await post<null, EnterpriseVerifyApply[]>("/audit/enterprise/getAllProcessed", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const enterpriseAudit = async (params: EnterpriseAuditRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<EnterpriseAuditRequest, boolean>("/audit/enterprise/audit", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const enterpriseAuditApi = {
    getAllCandidates,
    getAllProcessed,
    enterpriseAudit
}; 